<template>
  <div v-if="loading" class="text-center" style="margin-top: 10em">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else>
    <transition appear name="slide-fade">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-header">
              <h4 class="text-orange fw-bold">Nuevo aliado</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-12 form-group">
                  <label>Ciudad</label>
                  <v-select
                    v-model="sucursal"
                    label="sucursal"
                    :options="sucursales"
                  ></v-select>
                </div>
                <div class="col-lg-12 form-group">
                  <label>Nombre</label>
                  <input v-model="nombre" class="form-control" type="text" />
                </div>
                <div class="col-lg-12 form-group">
                  <label>Estado</label>
                  <select v-model="estado" class="form-control">
                    <option value="0">Interesado</option>
                    <option value="1">Pendiente</option>
                    <option value="2">Completa</option>
                  </select>
                </div>
                <div class="col-lg-12 text-end">
                  <router-link
                    to="/aliados"
                    class="btn btn-outline-dark rounded-pill"
                  >
                    <i class="bx bx-chevron-left"></i> Cancelar
                  </router-link>
                  <button
                    v-on:click="set_aliado"
                    class="btn btn-success rounded-pill ms-1"
                  >
                    Siguiente <i class="bx bx-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Nuevo_aliado",
  data() {
    return {
      loading: true,
      sucursales: [],
      sucursal: null,
      nombre: null,
      estado: 1,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.get_sucursales();
  },
  methods: {
    get_sucursales: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "admin/sucursales", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.sucursales = response.data.data.sucursales;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_aliado: function () {
      if (this.sucursal == null) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Selecciona la ciudad a donde pertenece el aliado.",
        });
        return false;
      }
      if (this.nombre == null || this.nombre.trim().length == 0) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Digita el nombre del aliado.",
        });
        return false;
      }

      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_sucursal: this.sucursal.id_sucursal,
        nombre_aliado: this.nombre,
        estado: this.estado,
      };
      axios
        .post(this.$base_url + "aliados/set_aliado", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }
          vm.$router.push("/aliado/" + response.data.data.id_aliado);
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
  mounted: function () {},
};
</script>